import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../style/Fournisseur.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import NotesFournisseur from "./NotesFournisseur.jsx";
import { logOut } from "../../utils/login";
import SunEditor from "suneditor-react";
import { useHistory } from "react-router-dom";
import "suneditor/dist/css/suneditor.min.css";
import Representant from "./Representant";
import ModalAvertissement from "./ModalAvertissement";

import { useToasts } from "react-toast-notifications";
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBIcon,
} from "mdbreact";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function FournisseurMontures() {
  const [show, setShow] = useState(false);
  const [fournisseur, setFournisseur] = useState([]);
  const { fournisseurId } = useParams();
  const [codeClient, setCodeClient] = useState();
  const [newCodeClient, setNewCodeClient] = useState();
  const [agenceFavorite, setAgenceFavorite] = useState(-1);
  const [newAgenceFavorite, setNewAgenceFavorite] = useState();
  const [notes, setNotes] = useState();
  const [refresh, setRefresh] = useState(false);
  const [showAvertissement, setShowAvertissement] = useState(false);
  const type = 3;
  let counter = -1;

  const history = useHistory();
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);
  const loggedIn = useSelector((state) => state.login);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowAvertissement = () => setShowAvertissement(true);

  const getFournisseur = () =>
    axios.get(`${API_URL}/api/verriers/${fournisseurId}`);
  const getNotes = () =>
    axios.get(`${API_URL}/api/notes/${type}/${fournisseurId}`, {
      headers: { authorization: `Bearer ${token}` },
    });

  useEffect(() => {
    function getFournisseurAndNotes() {
      axios
        .all([getFournisseur(), loggedIn ? getNotes() : null])
        .then((res) => {
          setFournisseur(res[0].data);
          if (loggedIn && res[1].data.notes) {
            setNotes(res[1].data.notes);
          }
          if (loggedIn) {
            setCodeClient(res[1].data.code_client);
          }
          if (loggedIn && res[1].data.agence_favorite >= 0) {
            setNewAgenceFavorite(res[1].data.agence_favorite);
            setAgenceFavorite(res[1].data.agence_favorite);
          }
          if (loggedIn && res[0].data.length === 1) {
            setAgenceFavorite(0);
            setNewAgenceFavorite(0);
          }
        })
        .catch((e) => {
          if (e.response.status === 401) {
            addToast("Votre session est expirée. Merci de vous reconnecter.", {
              appearance: "warning",
              autoDismiss: true,
            });
            logOut();
            dispatch({ type: "LOGOUT" });
            history.push("/login");
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }

    getFournisseurAndNotes();
  }, [refresh]);

  const handleChange = (e) => {
    const { value } = e.target;
    setNewAgenceFavorite(() => parseInt(value));
  };

  const handleChangeCodeClient = (e) => {
    const { value } = e.target;
    setNewCodeClient(() => value);
  };

  function handleSubmit() {
    const newNote = notes;
    axios
      .put(
        `${API_URL}/api/notes/fournisseur/${fournisseurId}`,
        { newNote, type, newCodeClient, newAgenceFavorite },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        addToast("Mise à jour effectuée !", {
          appearance: "success",
          autoDismiss: true,
        });
        setRefresh(!refresh);
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  return (
    <div className="fournisseurMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{fournisseur.nom}</title>
      </Helmet>
      <a
        href={fournisseur[0] ? fournisseur[0].site_url : undefined}
        target="_blank"
        rel="noreferrer"
        className="fournisseurTitleSpan"
      >
        <span>
          {fournisseur[0] ? (
            <img
              src={`${API_URL}/images/fournisseurs-verres/${fournisseur[0].fournisseur_verre_id}.png`}
              alt="Logo"
              className="fournisseurLogo"
            />
          ) : (
            "Loading"
          )}
          <h1>
            {fournisseur[0]
              ? `${fournisseur[0].nomFournisseur
                  .charAt(0)
                  .toUpperCase()}${fournisseur[0].nomFournisseur.slice(1)}`
              : null}
          </h1>
        </span>
      </a>
      <h2>Contact</h2>
      {fournisseur.length > 1 ? (
        <select
          name="agence_id"
          id="agence-select"
          onChange={handleChange}
          className=""
        >
          <option value="-1">Choisissez votre agence</option>
          {fournisseur.map(function fn(adresse) {
            counter++;
            return (
              <option
                value={counter}
                selected={agenceFavorite === counter ? "selected" : null}
              >
                {adresse.nom}
              </option>
            );
          })}
          ;
        </select>
      ) : null}
      {agenceFavorite >= -1 &&
        fournisseur.length > 1 &&
        agenceFavorite !== newAgenceFavorite && (
          <button
            className="linkButton"
            onClick={loggedIn ? handleSubmit : handleShowAvertissement}
          >
            {" "}
            ★ Afficher cette agence par défaut
          </button>
        )}
      {agenceFavorite >= -1 && fournisseur[newAgenceFavorite] ? (
        <address>
          {fournisseur[newAgenceFavorite].adresse_rue_1}
          <br />
          {fournisseur[newAgenceFavorite].adresse_rue_2}
          {fournisseur[newAgenceFavorite].adresse_rue_2 ? <br /> : null}
          {fournisseur[newAgenceFavorite].adresse_code_postal}{" "}
          {fournisseur[newAgenceFavorite].adresse_ville}
          <br />
          {fournisseur[newAgenceFavorite].adresse_pays}
          {fournisseur[newAgenceFavorite].adresse_pays ? <br /> : null}
          <br />
          <MDBIcon icon="globe" />{" "}
          <a
            href={fournisseur[0] ? fournisseur[0].site_url : undefined}
            target="_blank"
            rel="noreferrer"
          >
            Site internet
          </a>
          <br />
          <MDBIcon icon="phone" /> {fournisseur[newAgenceFavorite].telephone}
          <br />
          {fournisseur[newAgenceFavorite].fax && (
            <div>
              <MDBIcon icon="fax" /> {fournisseur[newAgenceFavorite].fax}
              <br />
            </div>
          )}
          {fournisseur[newAgenceFavorite].telephone_contact_technique && (
            <div>
              <MDBIcon icon="wrench" />{" "}
              {fournisseur[newAgenceFavorite].telephone_contact_technique}
              <br />
            </div>
          )}
          {fournisseur[newAgenceFavorite].email && (
            <div>
              <MDBIcon icon="envelope" />{" "}
              <a href={`mailto: ${fournisseur[newAgenceFavorite].email}`}>
                {" "}
                {fournisseur[newAgenceFavorite].email}{" "}
              </a>
              <br />
            </div>
          )}
        </address>
      ) : (
        <div>
          <br />
          <p>Merci de sélectionner une agence afin d'en voir les coordonnées</p>
        </div>
      )}
      <b>Code client : </b>{" "}
      {codeClient ? (
        codeClient
      ) : (
        <i>Aucun code n'a été saisi pour le moment'</i>
      )}
      <button
        type="button"
        className="linkButton"
        onClick={loggedIn ? handleShow : handleShowAvertissement}
      >
        Modifier
      </button>
      <MDBModal isOpen={show} onHide={handleClose}>
        <MDBModalHeader>Enregistrement du code client</MDBModalHeader>
        <MDBModalBody>
          <input className="modalInput" onChange={handleChangeCodeClient} />
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn type="button" outline color="primary" onClick={handleClose}>
            Fermer
          </MDBBtn>
          <MDBBtn
            type="button"
            color="primary"
            onClick={() => {
              handleSubmit();
              handleClose();
            }}
          >
            Ajouter
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
      <h2 className="FournisseursH2">Mes représentants</h2>
      <Representant
        type={type}
        fournisseurId={fournisseurId}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <h2 className="FournisseursH2">Notes</h2>
      <SunEditor
        lang="fr"
        width="80%"
        height="auto"
        autoFocus={true}
        setContents={notes}
        disable={true}
        showToolbar={false}
        setOptions={{ showPathLabel: false, resizingBar: false }}
      />
      <NotesFournisseur
        notes={notes}
        setNotes={setNotes}
        fournisseurId={fournisseurId}
        refresh={refresh}
        setRefresh={setRefresh}
        codeClient={codeClient}
        agenceFavorite={agenceFavorite}
        type={type}
      />
      <ModalAvertissement
        showAvertissement={showAvertissement}
        setShowAvertissement={setShowAvertissement}
      />
    </div>
  );
}

export default FournisseurMontures;
